import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {tagPicker_template} from "./tagPicker_template";
import {imagePicker_template} from '../../../vendor/valnet/valnet_imagePicker/js/components/templates/imagePicker_template';
import {filterArticle_template} from "./filterArticle_template";
import {filterAutocomplete_template} from "./filterAutocomplete_template";
import {
    filterDropdown_template
} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";
import {imagePickerHelper} from '../../../vendor/valnet/valnet_imagePicker/js/modules/imagePickerHelper';
import {newsletterTargetingBuilder_template} from "./newsletterTargetingBuilder_template";

declare var ko: any;

export class newsletterInteractionEmailEdit_template extends vnTemplate {

    public imagePicker: imagePicker_template;
    public tagPicker: tagPicker_template;
    public articleFilter: filterArticle_template
    public filterProducts: filterAutocomplete_template;
    public filterAffiliates: filterAutocomplete_template;
    public filterProductTypes: filterAutocomplete_template;
    public eventSelector: filterDropdown_template;
    public templateSelector: filterDropdown_template;
    public scheduleSelector: filterDropdown_template;
    public targetingBuilder: newsletterTargetingBuilder_template;
    public imagePickerHelper: imagePickerHelper;


    protected getTemplateHtml(): string {

        return `
            <div data-bind="visible: !id() && !mode()" class="w-form temp-selector-new is-showing" style="display:inline-block; min-width:70rem">
                <div class="form-header">
                    <strong class="form-title">Select Layout</strong>
                    <button data-bind="event: { click: onClickCancelEdit }" class="close-button icon i-close-2" type="button"></button>
                </div>
                <div class="w-form-body"><div class="form-body">
                    <div class="form-group group-3" style="grid-template-columns:none"><button class="btn-temp-new temp-regular" type="button" data-bind="click: () => onClickSelectMode('regular')"><div class="w-icon"><span class="icon i-newsletter"></span></div><div class="temp-info"><span>Regular</span><p>Provides standard elements with CSS automatically applied</p></div></button></div>
                    <div class="form-group group-4" style="grid-template-columns:none"><button class="btn-temp-new temp-regular" type="button" data-bind="click: () => onClickSelectMode('Custom Content')"><div class="w-icon"><span class="icon i-star-full"></span></div><div class="temp-info"><span>Custom Content</span><p>Allows custom elements and inline CSS within the content. Uses the template header and footer.</p></div></button></div>
                    <div class="form-group group-5" style="grid-template-columns:none"><button class="btn-temp-new temp-regular" type="button" data-bind="click: () => onClickSelectMode('Custom Header/Content/Footer')"><div class="w-icon"><span class="icon i-star-full"></span></div><div class="temp-info"><span>Custom Header/Content/Footer</span><p>Allows full control within the body tag. Does not include a header, content, or footer.</p></div></button></div>
                </div></div>
            </div>

            <div data-bind="visible: !id() && (mode() == 'Custom Content' || mode() == 'Custom Header/Content/Footer') && !selectedTemplateId()" class="w-form temp-selector-new is-showing" style="display:inline-block; min-width:70rem">
                <div class="form-header"><strong class="form-title">Select Template</strong><button data-bind="event: { click: onClickCancelEdit }" class="close-button icon i-close-2" type="button"></button></div>
                <div class="w-form-body"><div class="form-body"><div class="form-group group-4 overflow-scroll" data-bind="foreach: availableTemplates"><button class="btn-temp-new temp-regular" type="button" data-bind="click: ($data) => $parent.onClickSelectTemplate($data)"><div class="w-icon"><span class="icon i-regular-template"></span></div><div class="temp-info"><span data-bind="text: name"></span></div></button></div></div></div>
            </div>

            <div class="w-form w-form-large" data-bind="visible: mode() == 'regular' || ((mode() == 'Custom Content' || mode() == 'Custom Header/Content/Footer') && selectedTemplateId())">
                <div class="form-header">
                    <h3 class="form-title">Newsletter Interaction Email</h3>
                    <h3 class="form-title" data-bind="text: name"></h3>
                    <button data-bind="event: { click: onClickCancelEdit }" class="close-button icon i-close-2" type="button"></button>
                    
                </div>
                <div class="w-form-body">
                    <div class="form-body">
                       
                        <div class="form-group">
                            <label for="subject" class="form-label">Subject</label>
                            <div class="row link">
                                <input id="subject" data-bind="value: subject" type="text" class="input-text">
                            </div>
                        </div>
                        
                        <div class="form-group">
                            <label for="previewText" class="form-label">Preview Text</label>
                            <div class="row link">
                                <input id="previewText" data-bind="value: previewText" type="text" class="input-text">
                            </div>
                        </div>
                        <div class="form-group">
                             <label for="event" class="form-label">Event</label>
                             ${this.eventSelector.getHtmlBuild()}
                        </div>
                        <div class="form-group">
                            <dl class="double-list">
                                <dt><span>Layout</span></dt>
                                <dd><span data-bind="text: mode"></span></dd>
                            </dl>
                            <dl class="double-list">
                                <dt><span>Template</span></dt>
                                <dd><span data-bind="text: selectedTemplateName"></span></dd>
                            </dl>
                        </div>
                    </div>
                </div>
                
                <div class="w-form-body">
                    <div class="form-body w-interactions-email">    
                        <div class="form-group">
                             <label for="contentText" class="form-label">Content</label>
                             <textarea id="contentText" data-bind="value: content" ></textarea>
                        </div> 
                        
                    </div> 
                </div>  
                
                 <div class="form-footer">                
                    <button data-bind="event: { click: onClickCancelEdit }" class="btn " type="button">Cancel</button>
                    <button data-bind="event: { click: onClickSave }" class="btn highlight" type="button">Save</button>            
                    <button data-bind="event: { click: onClickToggleSaveAndSendPopUp.bind($data, true) }" class="btn highlight" type="button">Save & Activate</button>
                </div>
            </div>  

            <div data-bind="css: { 'is-visible': isSaveAndSendPopUpVisible }" class="w-lightbox light-theme lightbox-embed">
                <div class="lightbox-content" id="interaction-email-confirm-identifier">
                    <div class="w-form lightbox-form" style="width: 100rem">
                        <div class="form-header">
                            <h3 class="form-title">Save & Activate Event Email</h3>
                            <button type="button" class="close-button icon i-close-2" data-bind="event: { click: onClickToggleSaveAndSendPopUp.bind($data, false) }"></button>
                        </div>
                        <div class="form-body newsletter-save-send-body">
                            <strong class="form-sub-title">Information</strong>
                            <div class="form-group">
                                <div class="form-check-inline" data-bind="visible: mode() == 'regular'">
                                    <label class="form-label">Template</label>
                                    ${this.templateSelector.getHtmlBuild()}
                                </div>
                                <div class="form-check-inline">
                                    <label class="form-label">Schedule</label>
                                    ${this.scheduleSelector.getHtmlBuild()}
                                </div>
                            </div>

                            <strong class="form-sub-title parent">Recipients</strong>
                            <div class="form-group newsletter-recipient-modes">
                                <div class="form-check-inline"><input id="interaction-recipient-mode-mailing-list" type="radio" name="interactionRecipientMode" value="mailingList" data-bind="checked: recipientMode"><label for="interaction-recipient-mode-mailing-list" class="form-label">Mailing List</label></div>
                                <div class="form-check-inline"><input id="interaction-recipient-mode-segment" type="radio" name="interactionRecipientMode" value="segment" data-bind="checked: recipientMode"><label for="interaction-recipient-mode-segment" class="form-label">Segment</label></div>
                                <div class="form-check-inline"><input id="interaction-recipient-mode-custom" type="radio" name="interactionRecipientMode" value="custom" data-bind="checked: recipientMode"><label for="interaction-recipient-mode-custom" class="form-label">Custom</label></div>
                            </div>

                            <div data-bind="visible: recipientMode() === 'mailingList'">
                                <strong class="form-sub-title content">Mailing Lists</strong>
                                <div class="form-group mailinglist" data-bind="foreach: recipients">
                                    <input type="checkbox" data-bind="attr: {id: 'interaction-recipient-' + id}, value: id, checked: $parent.selectedRecipients"><label class="form-label icon i-check" data-bind="text: name, attr: {for: 'interaction-recipient-' + id}"></label>
                                </div>
                            </div>

                            <div data-bind="visible: recipientMode() === 'segment'">
                                <strong class="form-sub-title content">Segments</strong>
                                <div class="form-group mailinglist" data-bind="foreach: availableSegments">
                                    <input type="checkbox" data-bind="attr: {id: 'interaction-segment-' + id}, value: id, checked: $parent.selectedSegmentIds"><label class="form-label icon i-check" data-bind="text: title, attr: {for: 'interaction-segment-' + id}"></label>
                                </div>
                            </div>

                            <div data-bind="visible: recipientMode() === 'custom'">
                                <strong class="form-sub-title content">Custom Targeting</strong>
                                <p class="form-text">Direct email recipients are added to the event email and are not filtered by targeting rules.</p>
                                ${this.targetingBuilder.getHtmlBuild()}
                            </div>

                            <div class="form-group"><hr class="form-hr"></div>
                            <div class="newsletter-segment-audience-accordion">
                                <strong class="form-sub-title content newsletter-segment-audience-accordion-title icon i-dropdown-simple" data-bind="event: { click: onClickToggleAudienceTools }, css: { 'is-open': isAudienceToolsOpen }, attr: { 'aria-expanded': isAudienceToolsOpen() ? 'true' : 'false' }">Audience Tools</strong>
                                <div data-bind="visible: isAudienceToolsOpen">
                                    <div class="form-group newsletter-segment-audience-tools">
                                        <div class="newsletter-segment-audience-count">
                                            <button type="button" class="btn secondary" data-bind="event: { click: onClickCalculateRecipientCount }, disable: isRecipientCountLoading, css: { 'is-loading': isRecipientCountLoading }">Calculate Count of Targeted Email Addresses</button>
                                            <span class="form-text" data-bind="text: recipientCountLabel"></span>
                                            <!-- ko if: permissions()['website_user_export'] && permissions()['website_user_export'].read -->
                                            <button type="button" class="btn secondary icon i-export" data-bind="event: { click: onClickExportAudience }, disable: isAudienceExportLoading, css: { 'is-loading': isAudienceExportLoading }">Export CSV of Targeted Email Addresses</button>
                                            <!-- /ko -->
                                        </div>
                                        <div class="newsletter-segment-audience-lookup"><label class="form-label">User Lookup</label><textarea class="input-text newsletter-segment-lookup-input" data-bind="value: audienceLookupEmails" placeholder="email@example.com, other@example.com"></textarea><button type="button" class="btn secondary" data-bind="event: { click: onClickLookupAudience }, disable: isAudienceLookupLoading, css: { 'is-loading': isAudienceLookupLoading }">Check if Email Addresses are Targeted</button></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-footer"><button type="button" data-bind="event: { click: onClickToggleSaveAndSendPopUp.bind($data, false) }" class="btn">Cancel</button><button type="button" data-bind="event: { click: onClickConfirmEventConfiguration }" class="btn highlight">Save & Activate</button></div>
                    </div>
                </div>
            </div>

            <div class="w-lightbox light-theme" data-bind="css: { 'is-visible': isAudienceLookupResultsVisible }">
                <div class="lightbox-content"><div class="w-form lightbox-form newsletter-segment-lookup-results-popup"><div class="form-header"><h3 class="form-title">Check Email Results</h3><button type="button" data-bind="event: { click: onClickCloseAudienceLookupResults }" class="close-button icon i-close-2"></button></div><div class="form-body"><div class="form-group" data-bind="foreach: audienceLookupResults"><p class="form-text"><strong data-bind="text: email"></strong>: <span data-bind="text: matches ? 'Targeted' : 'Not targeted'"></span></p></div></div></div></div>
            </div>
            
            ` + this.imagePicker.getHtmlBuild() + `
            ` + this.tagPicker.getHtmlBuild() + `
            
            <div data-bind="css: { 'is-visible': isArticleInsertPopUpVisible }" class="w-lightbox light-theme lightbox-embed">
                <div class="lightbox-content">
                    <div class="w-form lightbox-form">
                        <div class="form-header">
                            <h3 class="form-title">Article</h3>
                            <button type="button" class="close-button icon i-close-2" data-bind="event: { click: onClickCloseArticlePopUp }" ></button>
                        </div>
                        <div class="form-body w-article-picker" style="padding:2rem">
                            ${this.articleFilter.getHtmlBuild()}
                            <div class="preview" data-bind="visible: articleInsertPreviewCode">
                                <div class="form-group">
                                    <div class="scrollable" style="max-width:50vw;"  data-bind="html: articleInsertPreviewCode, disable: true" ></div>
                                </div>
                            </div>
                        </div>
                        <div class="form-footer">
                            <button type="button" data-bind="event: { click: onClickCloseArticlePopUp }" class="btn ">Cancel</button>
                            <button type="button" data-bind="disable: articleInsertPreviewCode() == '',  event: { click: onClickInsertIntoEditor }" class="btn highlight">Insert</button>
                        </div>
                    </div>
                </div>
            </div>
            `;

    }

    protected getTemplateName(): string {

        return "newsletterInteractionEmailEdit-template";
    }

    protected getMainElementClasses(): Array<string> {

        return ["div"];
    }

    public showTagPicker(mode, target){

        this.tagPicker.setMode(mode);
        this.tagPicker.setTarget(target);
        this.setTagPickerTarget(target);
        this.tagPicker.show();
    }

    public setTagPickerTarget(tagPickerTarget){

        this.getTemplateViewModel().tagPickerTarget(tagPickerTarget);
    }

    protected initPartial() {

        this.imagePicker = new imagePicker_template("imagePicker", this.getTemplateViewModel(), this.caller);
        this.imagePicker.setNumberOfRecentImages(50);

        this.tagPicker = new tagPicker_template("tagPicker", this.getTemplateViewModel(), this.caller);
        this.tagPicker.setParent(this);

        this.articleFilter = new filterArticle_template("filterArticle", this.getTemplateViewModel(), this.caller);
        this.articleFilter.setShowDetails(true);
        this.articleFilter.setIsLoadingAnimationEnable(true);

        this.filterProducts = new filterAutocomplete_template("filterAutocompleteProduct_template", this.getTemplateViewModel(), this.caller);
        this.filterProducts.setClearInputConfirmMessage("Are you sure you want to change the product name? Newly entered product specifications and selected fields will be lost");
        this.filterProducts.setAddNewClearConfirmMessage("Are you sure you want to add a new product name? Newly entered product specifications and selected fields will be lost");
        this.filterProducts.setAddNewOptionEnabled(true);
        this.filterProducts.setHasDisplayNameComplement(true);
        this.filterProducts.setNumberOfChars( 1 );
        this.filterProducts.setPlaceholderAndLabel( "Product" );
        this.filterProducts.setOptionType("Product name");

        this.filterAffiliates = new filterAutocomplete_template("filterAutocompleteAffiliate_template", this.getTemplateViewModel(), this.caller);
        this.filterAffiliates.setAddNewOptionEnabled(true);
        this.filterAffiliates.setNumberOfChars( 1 );
        this.filterAffiliates.setPlaceholderAndLabel( "Affiliate Partner" );
        this.filterAffiliates.setOptionType("Affiliate Partner");

        this.filterProductTypes = new filterAutocomplete_template("filterAutocompleteProductType_template", this.getTemplateViewModel(), this.caller);
        this.filterProductTypes.setClearInputConfirmMessage("Are you sure you want to change the product type? Newly entered product specifications and selected fields will be lost");
        this.filterProductTypes.setAddNewClearConfirmMessage("Are you sure you want to add a new product type? Newly entered product specifications and selected fields will be lost");
        this.filterProductTypes.setPlaceholderAndLabel( 'Product Type' );
        this.filterProductTypes.setOptionType("Product Type");
        this.filterProductTypes.setNumberOfChars( 1 );
        this.filterProductTypes.setAddNewOptionEnabled(true);
        
        this.eventSelector = new filterDropdown_template('eventSelector', this.getTemplateViewModel(), this.caller);
        this.eventSelector.setLabel('Event');

        this.templateSelector = new filterDropdown_template('interactionEmailTemplateSelector', this.getTemplateViewModel(), this.caller);
        this.templateSelector.setLabel('Template');

        this.scheduleSelector = new filterDropdown_template('interactionEmailScheduleSelector', this.getTemplateViewModel(), this.caller);
        this.scheduleSelector.setLabel('Schedule');

        this.targetingBuilder = new newsletterTargetingBuilder_template('interactionEmailTargetingBuilder', this.getTemplateViewModel(), this.caller);

        this.imagePickerHelper = new imagePickerHelper(
            this.imagePicker,
            this.caller.viewModel, 
            this.caller.getVnAppZone(),
            this.caller
        );
    }

    protected buildViewModel(): any {
        let self = this
        return {
            id: ko.observable(""),
            subject: ko.observable(""),
            previewText: ko.observable(""),
            content: ko.observable(""),
            mode: ko.observable(""),
            selectedTemplateId: ko.observable(null),
            selectedTemplateName: ko.observable(""),
            availableTemplates: ko.observableArray([]),
            recipients: ko.observableArray([]),
            selectedRecipients: ko.observableArray([]),
            availableSegments: ko.observableArray([]),
            selectedSegmentIds: ko.observableArray([]),
            recipientMode: ko.observable('mailingList'),
            recipientEmails: ko.observable(''),
            isSaveAndSendPopUpVisible: ko.observable(false),
            isAudienceToolsOpen: ko.observable(false),
            isRecipientCountLoading: ko.observable(false),
            isAudienceExportLoading: ko.observable(false),
            isAudienceLookupLoading: ko.observable(false),
            recipientCount: ko.observable(null),
            audienceLookupEmails: ko.observable(''),
            audienceLookupResults: ko.observableArray([]),
            isAudienceLookupResultsVisible: ko.observable(false),
            recipientCountLabel: ko.pureComputed(function () {
                if (self.getTemplateViewModel().isRecipientCountLoading()) {
                    return 'Calculating audience...';
                }
                let count = self.getTemplateViewModel().recipientCount();
                return count === null ? '' : 'Audience count: ' + Number(count).toLocaleString();
            }),
            isArticleInsertPopUpVisible: ko.observable(false),
            articleInsertPreviewCode: ko.observable(''),
            imagePickerTarget: ko.observable(null),
            tagPickerTarget: ko.observable(null),
            articlePickerTarget: ko.observable(null),
            permissions: ko.observableArray(this.initPermissions([ 'newsletter_interaction_emails'])),
            onClickCancelEdit: function (data, event) {
                self.cancelEdit();

            },
            onClickSave: function (data, event) {
                self.onClickSave()
            },
            onClickToggleSaveAndSendPopUp: function (value) {
                self.toggleSaveAndSendPopUp(value);
            },
            onClickConfirmEventConfiguration: function () {
                self.onClickConfirmEventConfiguration();
            },
            onClickCalculateRecipientCount: function () {
                self.onClickCalculateRecipientCount();
            },
            onClickExportAudience: function () {
                self.onClickExportAudience();
            },
            onClickLookupAudience: function () {
                self.onClickLookupAudience();
            },
            onClickCloseAudienceLookupResults: function () {
                self.getTemplateViewModel().isAudienceLookupResultsVisible(false);
            },
            onClickToggleAudienceTools: function () {
                let viewModel = self.getTemplateViewModel();
                viewModel.isAudienceToolsOpen(!viewModel.isAudienceToolsOpen());
            },
            onClickCloseArticlePopUp: function (data, event) {
                self.onClickCloseArticlePopUp();
            },
            onClickInsertIntoEditor: function (data, event) {
                self.onClickInsertIntoEditor();
            },
            onClickSelectMode: function (mode) {
                self.selectMode(mode);
            },
            onClickSelectTemplate: function (template) {
                self.selectTemplate(template);
            },
        }
    }

    getViewModelForRequest(): any {

        return {
            idInteractionEmail: this.getTemplateViewModel().id(),
            subject: this.getTemplateViewModel().subject(),
            previewText: this.getTemplateViewModel().previewText(),
            event: this.eventSelector.getTemplateViewModel().selectedOption,
            mode: this.getTemplateViewModel().mode(),
            template: this.getTemplateViewModel().mode() === 'regular'
                ? this.templateSelector.getTemplateViewModel().selectedOption
                : this.getTemplateViewModel().selectedTemplateId(),
            content: this.getTemplateViewModel().content(),
            schedule: this.scheduleSelector.getTemplateViewModel().selectedOption,
            recipientMode: this.getTemplateViewModel().recipientMode(),
            selectedRecipients: this.getTemplateViewModel().selectedRecipients(),
            selectedSegmentIds: this.getTemplateViewModel().selectedSegmentIds(),
            targeting: this.getAudienceCriteria(),
            recipientEmails: this.getTemplateViewModel().recipientEmails(),
        };
    }

    public setId( id) {

        this.getTemplateViewModel().id(id);
    }

    public setEvents(options) {

        this.eventSelector.setOptions(options.map((event) => ({id: event.reference, name: event.name})));
        this.eventSelector.setSelectedOption('custom');
    }
   
    public setTemplates( options) {

        this.getTemplateViewModel().availableTemplates(options);
        this.templateSelector.setOptions(options);
    }

    public setSchedules(options) {
        this.scheduleSelector.setOptions(options.map((schedule) => ({id: schedule.reference, name: schedule.name})));
        this.scheduleSelector.setSelectedOption('immediately_after_event');
    }

    public setRecipients(recipients) {
        this.getTemplateViewModel().recipients(recipients || []);
    }

    public setTargetingReferences(references) {
        this.targetingBuilder.setReferences(references);
        this.getTemplateViewModel().availableSegments((references.segments || []).map((segment) => ({
            id: segment.id,
            title: segment.title || segment.name,
        })));
    }

    public setEventConfiguration(interactionEmail) {
        const configuration = interactionEmail.recipientConfiguration || {};
        this.scheduleSelector.setSelectedOption(interactionEmail.eventSchedule || 'immediately_after_event');
        this.getTemplateViewModel().recipientMode(interactionEmail.recipientMode || 'mailingList');
        this.getTemplateViewModel().selectedRecipients(configuration.mailingListIds || []);
        this.getTemplateViewModel().selectedSegmentIds(configuration.segmentIds || []);
        this.getTemplateViewModel().recipientEmails(configuration.recipientEmails || '');
        this.targetingBuilder.setCriteria(configuration.targeting || this.getDefaultTargetingCriteria());
    }

    public setSubject(subject) {

        this.getTemplateViewModel().subject(subject)
    }
    
    public setPreviewText(previewText) {

        this.getTemplateViewModel().previewText(previewText)
    }

    public setContent( content) {

        this.getTemplateViewModel().content(content);
    }

    public setMode(mode) { this.getTemplateViewModel().mode(mode || ''); }

    public setSelectedTemplate(template) {
        this.getTemplateViewModel().selectedTemplateId(template ? template.id : null);
        this.getTemplateViewModel().selectedTemplateName(template ? template.name : '');
        this.templateSelector.setSelectedOption(template ? template.id : null);
    }

    public selectMode(mode) { this.setMode(mode); }

    public selectTemplate(template) { this.setSelectedTemplate(template); }
   
    public showImagePicker(mode,target, keyword = null){

        this.imagePicker.setMode(mode);
        this.setImagePickerTarget(target);
        this.imagePicker.setTarget(target);
        this.caller.getImageData(keyword);
        if(mode == "multi-select"){
            this.caller.getImagesInContent(target);
        }
        this.imagePicker.show();
    }

    public getImagePickerTarget(){

        return this.getTemplateViewModel().imagePickerTarget();
    }

    public setImagePickerTarget(imagePickerTarget){

        this.getTemplateViewModel().imagePickerTarget(imagePickerTarget);
    }

    public getArticlePickerTarget(){

        return this.getTemplateViewModel().articlePickerTarget();
    }

    public setArticlePickerTarget(articlePickerTarget){

        this.getTemplateViewModel().articlePickerTarget(articlePickerTarget);
    }

    public onClickSave(){

        this.caller.save();
    }

    public onClickConfirmEventConfiguration() {
        this.caller.save(true);
    }

    public onClickCalculateRecipientCount() {
        this.caller.refreshRecipientCount();
    }

    public onClickExportAudience() {
        this.caller.exportAudience();
    }

    public onClickLookupAudience() {
        this.caller.lookupAudience();
    }

    public toggleSaveAndSendPopUp(isVisible: boolean) {
        this.getTemplateViewModel().isSaveAndSendPopUpVisible(isVisible);
        document.body.classList.toggle('_newsletter-save-send', isVisible);
    }

    public getAudienceCriteria() {
        const viewModel = this.getTemplateViewModel();
        if (viewModel.recipientMode() === 'mailingList') {
            return this.buildReferenceCriteria('mailingList', viewModel.selectedRecipients());
        }
        if (viewModel.recipientMode() === 'segment') {
            return this.buildReferenceCriteria('segment', viewModel.selectedSegmentIds());
        }
        return this.targetingBuilder.getCriteria();
    }

    private getDefaultTargetingCriteria() {
        return {version: 1, combinator: 'AND', filterGroups: [], exclusionGroups: [], externalEmails: []};
    }

    private buildReferenceCriteria(field: string, values: any[]) {
        return {
            version: 1,
            combinator: 'AND',
            filterGroups: values.length ? [{
                joinWithPrevious: 'AND',
                combinator: 'AND',
                conditions: [{field: field, operator: 'is_any_of', values: values}],
            }] : [],
            exclusionGroups: [],
            externalEmails: [],
        };
    }

    public isSectionForTagPicker(sectionName: string): boolean {

        let tpSections = ['featuredTag'];

        let fs =  tpSections.filter((s) => s == sectionName );

        return (fs.length > 0);
    }

    public editTagElement(tagElement, editor){

        this.showTagPicker("in-content", editor);
        this.tagPicker.editTagElement(tagElement);
    }

    public editTagGroup(groupElement, editor){

        this.showTagPicker("in-content", editor);
        this.tagPicker.setTagGroupElement(groupElement);
    }

    public initTagPickerCkEditors(): void{

        this.tagPicker.initializeCkEditors();
    }

    public getPermissions() {

        return this.getTemplateViewModel().permissions();
    }

    public toggleArticleInsertPopUp(bool){

        this.getTemplateViewModel().isArticleInsertPopUpVisible(bool)
    }

    public setArticleInsertPreviewCode(html){

        this.getTemplateViewModel().articleInsertPreviewCode(html)
    }

    public onClickCloseArticlePopUp(){

        this.toggleArticleInsertPopUp(false);
        this.resetArticleInsertPopUp();
    }

    public onClickInsertIntoEditor(){

        let html = this.getTemplateViewModel().articleInsertPreviewCode();
        this.caller.insertIntoEditor(html);
        this.resetArticleInsertPopUp();
        this.toggleArticleInsertPopUp(false);
    }

    public resetArticleInsertPopUp(){

        this.articleFilter.getTemplateViewModel().idArticle(null);
        this.articleFilter.getTemplateViewModel().article("");
        this.articleFilter.getTemplateViewModel().articleObj("");
        this.getTemplateViewModel().articleInsertPreviewCode("");
    }

    public setPermissions(permissions) {

        this.getTemplateViewModel().permissions(permissions)
        this.imagePicker.setPermissions(permissions);
        this.tagPicker.setPermissions(permissions);
    }

    public cancelEdit() {

        this.caller.redirectToInteractionEmailList()
    }

    public addTagPickerValidationClass() {

        document.body.classList.add('_tagpicker')
    }

    public removeTagPickerValidationClass() {

        document.body.classList.remove('_tagpicker')
    }

    public onChangeSelectTag() {

        let productsViewModel = this.filterProducts.getTemplateViewModel();
        let typesViewModel = this.filterProductTypes.getTemplateViewModel();
        let productTag = ! productsViewModel.addNewSelected() ?  productsViewModel.optionObj() : null;
        let tagType = ! typesViewModel.addNewSelected() ? typesViewModel.optionObj() : null;
        let specValues = productTag && productTag.specifications_extra ? JSON.parse( JSON.stringify(productTag.specifications_extra)) : [];

        let tagExtra = productTag && productTag.details ? JSON.parse( JSON.stringify(productTag.details)) : [];

        let seoDescription = tagExtra.shortDescription ? tagExtra.shortDescription : null;
        let productText = tagExtra.description ? tagExtra.description : null;
        let affiliateLinks = tagExtra.affiliateLinks ? tagExtra.affiliateLinks : [];
        let image = tagExtra.image ? tagExtra.image : null;

        this.getTemplateViewModel().reviewItemSeoDescription(seoDescription);
        this.getTemplateViewModel().reviewItemAffiliateLinks(affiliateLinks);

        this.caller.setReviewText(productText);

        if(image){

            this.addProductImage(image);
        }

        /*
            Here, the plan is, if you have a type and a product, get specifications extra from tag type field values extra
            otherwise if you only have a type, query for the fields only with

         */

        let specs = [], spec;

        if ( tagType && typeof tagType.fields != "undefined" && tagType.fields.length > 0 ) {

            tagType.fields.forEach( field => {

                spec = {fieldId: field.id, label: field.label, data: null,  dataType: field.dataType};

                for (let i=0; i< specValues.length; i++ ) {

                    if (specValues[i].idField == field.id ) {

                        spec['data'] = specValues[i].value;
                        specValues.splice(i,1);
                        break;
                    }
                }
                specs.push(spec);
            } )
        }
        if (productTag && productTag.details && productTag.details.image) {

            this.getTemplateViewModel().tagImage(productTag.details.image);
        }

        this.getTemplateViewModel().reviewItemTagSpecifications(specs)
    }

    public setProductImages(images) {

        for(let i = 0; i < images.length; i++) {
            this.addProductImage(images[i]);
        }
    }

    public addProductImage(image) {

        let imageSelected = this.getTemplateViewModel().reviewItemImages().find(x => x.id == image.id);
        if (!imageSelected) {
            let images = this.getTemplateViewModel().reviewItemImages();
            images.push(image);
            this.getTemplateViewModel().reviewItemImages([]);
            this.getTemplateViewModel().reviewItemImages(images);
        }
        this.onLoadTemplate('#img_list_product_review .img-article-item', this.reorderReviewItemImages.bind(this));

    }

    private onLoadTemplate(dragItemSelector, sortFunction) {

        var parent = this;
        var dragSrcEl = null;

        function handleDragStart(e) {
            // Target (this) element is the source node.
            dragSrcEl = this;

            //e.dataTransfer.setData('text', 'foo');
            e.dataTransfer.effectAllowed = 'move';
            e.dataTransfer.setData('text/html', this.outerHTML);

            this.classList.add('dragElem');
        }
        function handleDragOver(e) {
            if (e.preventDefault) {
                e.preventDefault(); // Necessary. Allows us to drop.
            }

            let huit_neuf_this = this;
            //var dragItems = document.querySelectorAll('[draggable=true]');
            var dragItems = document.querySelectorAll(dragItemSelector);
            let index = 0;
            let found = false;
            for (let item of dragItems) {
                if (dragSrcEl == item) {

                    huit_neuf_this.classList.add('after');
                    huit_neuf_this.classList.remove('before');
                    found = true;
                    break;
                }
                if (this == item) {

                    huit_neuf_this.classList.add('before');
                    huit_neuf_this.classList.remove('after');
                    found = true;
                    break;
                }
            }

            if (!found) {
                this.classList.add("before");
            }

            e.dataTransfer.dropEffect = 'move';  // See the section on the DataTransfer object.

            return false;
        }

        function handleDragEnter(e) {
            // this / e.target is the current hover target.
            //this.classList.add('over');

            //this.classList.add('before');
        }

        function handleDragLeave(e) {
            this.classList.remove('before');
            this.classList.remove('after');  // this / e.target is previous target element.
        }

        function handleDrop(e) {
            // this/e.target is current target element.

            if (e.stopPropagation) {
                e.stopPropagation(); // Stops some browsers from redirecting.
            }

            if (e.preventDefault) {
                e.preventDefault(); // Necessary. Allows us to drop.
            }

            // Don't do anything if dropping the same column we're dragging.
            if (dragSrcEl != this) {


                var dropHTML = e.dataTransfer.getData('text/html');

                if (dropHTML.includes("<li")) {
                    for (let child of this.parentNode.childNodes) {

                        if (child == dragSrcEl) {
                            this.parentNode.removeChild(dragSrcEl);
                        }
                    }

                    if (this.classList.contains("before")) {
                        this.insertAdjacentHTML('beforebegin', dropHTML);
                        var dropElem = this.previousElementSibling;
                    } else {
                        this.insertAdjacentHTML('afterend', dropHTML);
                        var dropElem = this.nextElementSibling;
                    }

                    addDnDHandlers(dropElem);
                    //this.reorderImages();
                }



            }
            sortFunction(parent);
            this.classList.remove('before');
            this.classList.remove('after');
            return false;
        }

        function handleDragEnd(e) {
            // this/e.target is the source node.
            this.classList.remove('before');
            this.classList.remove('after');

            [].forEach.call(cols, function (col) {
                col.classList.remove('before');
                col.classList.remove('after');
            });
        }

        function addDnDHandlers(elem) {
            elem.addEventListener('dragstart', handleDragStart, false);
            elem.addEventListener('dragenter', handleDragEnter, false)
            elem.addEventListener('dragover', handleDragOver, false);
            elem.addEventListener('dragleave', handleDragLeave, false);
            elem.addEventListener('drop', handleDrop, false);
            elem.addEventListener('dragend', handleDragEnd, false);

        }

        //var dragItems = document.querySelectorAll('[draggable=true]');
        var cols = document.querySelectorAll(dragItemSelector);
        [].forEach.call(cols, addDnDHandlers);
    }

    protected reorderReviewItemImages(huit_neuf_this) {
        let images = huit_neuf_this.getTemplateViewModel().reviewItemImages();
        let selector = '#img_list_product_review .img-article-item';
        let liElements = document.querySelectorAll(selector);

        //reorder the images based on HTML order
        let newImages = []
        for (let element of liElements) {

            let idElement = element.id;
            let image = images.find(i => i.id === Number(element.id));
            if (image) {
                newImages.push(image);
            }
        }
        huit_neuf_this.getTemplateViewModel().reviewItemImages([]);
        huit_neuf_this.getTemplateViewModel().reviewItemImages(newImages);
        huit_neuf_this.onLoadTemplate(selector, huit_neuf_this.reorderReviewItemImages.bind(huit_neuf_this));
    }

    private getFormattedEasternTimeZoneDateTime(): any {

        let date = this.createEasternTimeZoneDateTime();

        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();
        let hour = date.getHours();
        let minutes = date.getMinutes();

        return year + '/' + this.padInteger(month,2) + '/' + this.padInteger(day,2) + ' ' + this.padInteger(hour,2) + ':' + this.padInteger(minutes,2);
    }

    private createEasternTimeZoneDateTime(date?: Date): Date {

        if (!date) {
            date = new Date();
        }

        date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
        //checks if DST is currently being observed, adjusts offset accordingly
        let easternTimeOffset = this.isDstObserved(date) ? -240 : -300;
        date.setMinutes(date.getMinutes() + easternTimeOffset);

        return date;
    }

    private padInteger(number: number, size: number) {
        let s = number+"";
        while (s.length < size) s = "0" + s;
        return s;
    }

    public isDstObserved (date?: Date) {
        let jan = new Date(date.getFullYear(), 0, 1);
        let jul = new Date(date.getFullYear(), 6, 1);
        let stdTimezoneOffset = Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());

        return date.getTimezoneOffset() < stdTimezoneOffset;
    }

    public removeValidationClass() {

        document.body.classList.remove('_form-sub')
    }

    public handleTagInArticle(target: string): void {
        switch(target) {
            case 'tag_picker_edit_cancel':

                this.caller.clearValidationErrors();
                this.removeTagPickerValidationClass();
                this.tagPicker.tagEdit.hide();
                break;
            case 'tag_picker_edit':

                this.tagPicker.tagEdit.setTag(this.caller.getTagToEdit());
                this.tagPicker.tagEdit.show();
                break;
        }
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/newsletterInteractionEmailEdit_template.ts